module.exports = __webpack_public_path__ + "img/baomoyuan.51541bb6.jpg";